module.exports = __webpack_public_path__ + "img/57.ae75d30f.jpg";